import React, { useEffect, useRef } from "react";

const WalkAloneViz = () => {
  const vizRef = useRef(null);

  useEffect(() => {
    const vizElement = vizRef.current.getElementsByTagName("object")[0];
    vizElement.style.width = "120%";
    vizElement.style.height = "70vh";

    const scriptElement = document.createElement("script");
    scriptElement.src = "https://public.tableau.com/javascripts/api/viz_v1.js";
    vizElement.parentNode.insertBefore(scriptElement, vizElement);

    return () => {
      scriptElement.remove();
    };
  }, []);

  return (
    <div>
      <div
        ref={vizRef}
        className="tableauPlaceholder"
        id="viz1726481091720"
        style={{ position: "relative" }}
      >
        <noscript>
          <a href="#">
            <img
              alt="Survey Data on Perceptions of Safety While Walking Alone After Dark by Gender (2005-2022)"
              src="https://public.tableau.com/static/images/Wo/Women_Feeling_Safe/Sheet2/1_rss.png"
              style={{ border: "none" }}
            />
          </a>
        </noscript>
        <object className="tableauViz" style={{ display: "none" }}>
          <param name="host_url" value="https%3A%2F%2Fpublic.tableau.com%2F" />
          <param name="embed_code_version" value="3" />
          <param name="site_root" value="" />
          <param name="name" value="Women_Feeling_Safe/Sheet2" />
          <param name="tabs" value="no" />
          <param name="toolbar" value="yes" />
          <param
            name="static_image"
            value="https://public.tableau.com/static/images/Wo/Women_Feeling_Safe/Sheet2/1.png"
          />
          <param name="animate_transition" value="yes" />
          <param name="display_static_image" value="yes" />
          <param name="display_spinner" value="yes" />
          <param name="display_overlay" value="yes" />
          <param name="display_count" value="yes" />
          <param name="language" value="en-US" />
          <param name="filter" value="publish=yes" />
        </object>
      </div>
      <div className="viz-description">
        <p>
          This chart shows survey data on perceptions of safety while walking
          alone after dark by gender from 2005 to 2022. It highlights that men
          consistently feel safer than women across the years: In 2022, 9,370
          men felt safe compared to 8,480 women. Women feeling unsafe decreased
          from 2,460 in 2005 to 1,520 in 2022, while men's unsafe perception
          dropped from 1,010 to 630 over the same period. Overall, both genders
          have shown improvements in safety perception, but women still report
          feeling more unsafe than men.
        </p>
      </div>
    </div>
  );
};

export default WalkAloneViz;
